import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './index.scss';
import { LoadingSpinnerDotted } from '../loading-spinner/Loader';
import { changeDefaultCardService, deleteCardService } from '../../services/AdminService';

export default function CardModal({ modalType, showModal, setShowModal, cardData, listFnc }) {
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        // console.log(modalType);
        setIsLoading(true);
        const data = {
            paymentMethodId: cardData.id
        }
        if (modalType === "default") {
            await changeDefaultCardService(data, (res) => {
                if (res.status === 200) {
                    // console.log("changeDefaultCardService ==>", res.data);
                    setShowModal(false);
                } else {
                    console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                }
                setIsLoading(false);
                listFnc();
            });
        } else {
            await deleteCardService(data, (res) => {
                if (res.status === 200) {
                    // console.log("deleteCardService ==>", res.data);
                    setShowModal(false);
                } else {
                    console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                }
                setIsLoading(false);
                listFnc();
            });
        }
    }

    const handleClose = () => {
        setShowModal(false);
        setIsLoading(false);
    }

    // console.log(cardData);
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            keyboard={false}
            dialogClassName="modal-50w"
            centered
            className="card-modal-style"
        >
            <Modal.Body className='text-center'>
                <h3>{modalType && modalType === "default" ? "Update default card" : "Are you sure you want to delete this card?"}</h3>
                <p>{modalType && modalType === "default" ? "This card will be used by default for billing." : "This card will be deleted."}</p>
                <div className='m-card-info'>
                    <div className='m-card-title'><i className="bi bi-credit-card-2-back-fill"></i><span className="text-capitalize">{cardData?.card?.funding}</span> card</div>
                    <div className='m-card-no'><span className="text-capitalize">{cardData?.card?.brand}</span> ending in {cardData?.card?.last4}</div>
                </div>
                <div className='mt-2'>
                    <button className='btn btn-secondary-color btn-border-color' onClick={handleClose}>
                        Cancel
                    </button>
                    <button className={`btn ms-3 ${modalType === "default" ? "btn-primary-color" : "btn-danger"}`} disabled={isLoading} onClick={handleSubmit}>
                        {isLoading ? <LoadingSpinnerDotted /> : modalType === "default" ? "Update" : "Delete"}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}